<template>
  <EventiCards />
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import AppEvents from '@/event';
  import EventiCards from './eventi/EventiCards';
  export default {
    components: { EventiCards },
  };
</script>
